interface IWordingEntry {
    /**
     * namespace
     */
    namespace: string;
    /**
     * json entry
     */
    json: JSON;
}

/**
 * I18n-Class for locale-Handling
 */
export class I18n {
    private static instance: I18n;

    private entries: Array<IWordingEntry>;

    /**
     * @param path - the path within the JSON
     * @param value - the current json form the jsons array
     */
    private searchForValue (path: string, value: JSON): string {
        const tokens = path.split('.');

        const max = tokens.length;

        for (let i = 0; i < max; i++) {
            if (value && value[tokens[i]]) {
                value = value[tokens[i]];
            }
            else {
                return '';
            }
        }

        return `${value}`;
    }

    /**
     * Key - value functionality
     * @param namespace - the namespace that is used for querring the entry objects
     * @param path - the path within the JSON
     */
    public getValue (namespace: string, path: string): string {
        let returnValue = '';

        this.entries.forEach(entry => {
            if (entry.namespace === namespace) {
                const myValue = this.searchForValue(path, entry.json);

                if (myValue && myValue !== '') {
                    returnValue = `${myValue}`;
                }
            }
        });

        return returnValue;
    }

    /**
     * Singelton implementation
     * @param namespace - the namespace that is used for querring the entry objects
     * @param jsonObj - JSON object that holds the key value pairs
     */
    public static getInstance (namespace?: string, jsonObj?: object): I18n {
        if (!I18n.instance) {
            I18n.instance = new I18n();
            I18n.instance.entries = [];
        }

        /*
        if (!namespace && jsonObj) {
            console.log('%cERROR: Namespace is missing', 'color:red; font-size:12px');

            return;
        } else if (namespace && !jsonObj) {
            console.log('%cERROR: JSON is missing', 'color:red; font-size:12px');

            return;
        }
        */

        // if (jsonObj) {
        let hasBeenAddedYet = false;
        // check if json has been added yet
        I18n.instance.entries.forEach((/* entry*/) => {
            // if (JSON.stringify(entry.json) === JSON.stringify(jsonObj)) {
            hasBeenAddedYet = true;
            // }
        });

        if (!hasBeenAddedYet) {
            I18n.instance.entries.push({ namespace, json: jsonObj as JSON });
        }
        // }

        // if (I18n.instance.entries.length === 0) {
        //   console.log('%cERROR: No JSON has be specified', 'color:red; font-size:12px');
        // } else {
        return I18n.instance;
    //    }
    }
}
